import { DialogAction, PreparedDialogs } from './types';
import AboutNeolexon from '@/components/SharedComponents/AboutNeolexon/AboutNeolexon';
import { Kontakt } from '@/components/SharedComponents/CustomDropdown/Kontakt';
import { AccountDelete } from '@/components/SharedComponents/AccountDelete';
import { StarsDialog } from '@/components/StarsDialog';
import { NoPermission } from '@/components/NoPermission';
import { SelectHealthInsurance } from '@/screens/LicenseBooking/SelectHealthInsurance';

export const PREPARED_DIALOGS: PreparedDialogs = {
  logoutDialog: (onPress: DialogAction['onPress']) => ({
    title: 'Abmelden',
    content: 'Möchten Sie sich wirklich abmelden?',
    danger: true,
    confirmAction: {
      label: 'Abmelden',
      onPress,
    },
  }),
  aboutNeolexonDialog: () => ({
    title: 'Über neolexon Aphasie',
    contentComponent: () => <AboutNeolexon />,
    cancelable: false,
    cancelOnBackdropPress: true,
  }),
  kontaktDialog: () => ({
    title: 'Kontakt',
    contentComponent: () => <Kontakt />,
    cancelable: false,
    cancelOnBackdropPress: true,
  }),
  accountDeleteDialog: (onPress: DialogAction['onPress']) => ({
    title: 'Alle Daten unwiderruflich löschen',
    contentComponent: () => <AccountDelete />,
    confirmAction: {
      label: 'Unwiderruflich Löschen',
      onPress,
    },
    danger: true,
  }),
  selectHealthInsuranceDialog: (onStop) => ({
    title: 'Lizenz buchen',
    contentComponent: () => <SelectHealthInsurance />,
    cancelable: false,
    confirmAction: {
      label: 'Abbrechen',
      onPress: onStop,
    },
  }),
  starsProgressDialog: ({
    minutesExercised,
    stars,
    patient,
    onConfirm,
    onStop,
  }) => {
    return {
      title: `Toll! Heute schon ${minutesExercised} Minuten geübt!`,
      contentComponent: () => <StarsDialog stars={stars} patient={patient} />,
      confirmAction: {
        label: 'Weiter',
        onPress: onConfirm,
      },
      cancelAction: {
        label: 'Stop',
        onPress: onStop,
      },
      cancelOnBackdropPress: false,
      hideCloseButton: true,
    };
  },
  noPermissionDialog: () => {
    return {
      title: 'Zugang abgelaufen',
      contentComponent: () => <NoPermission />,
      cancelable: false,
      danger: true,
    };
  },
  noInternetDialog: () => ({
    title: 'Keine Verbindung',
    content:
      'Keine Verbindung zum neolexon Server. Überprüfen Sie Ihre Internetverbindung und versuchen es erneut.',
    danger: true,
    cancelable: false,
  }),
};
